import JWPlayer from "@jwplayer/jwplayer-react";

/**
 * JWVideoPlayer Component
 *
 * @param {string} library - JW Player library URL (e.g., https://cdn.jwplayer.com/libraries/xxxx.js)
 * @param {string} file - Video file URL
 * @param {string} image - Poster image URL
 * @param {string} playerId - Optional unique ID for the player (default: jw-player)
 * @param {object} config - Additional JW Player config options
 */
const JWVideoPlayer = ({
  library,
  file,
  image,
  playerId = "jw-player",
  config = {},
}) => {
  if (!library) {
    console.error("⚠️ Missing JW Player library URL");
    return <p>Error: JW Player library URL is required</p>;
  }

  return (
    <div style={{ width: "100%", maxWidth: 800, margin: "0 auto" }}>
      <JWPlayer
        library={library}
        playerId={playerId}
        file={file}
        image={image}
        config={{
          width: "100%",
          aspectratio: "16:9",
          autostart: false,
          mute: false,
          ...config,
        }}
      />
    </div>
  );
};

export default JWVideoPlayer;
